
export default function Preloader() {
    return (
        <>
            <div className="loader-wrapper">
                <div className="loader-circle">
                    <div className="loader-spinner"></div>
                    <img src="/img/logo-sampang.png" alt="Kabupaten Sampang" className="loader-logo" />
                </div>
                <p className="loader-text">Memuat data, mohon tunggu...</p>
            </div>
            <style jsx>{`
    .loader-wrapper {
      position: fixed;
      inset: 0;
      background: #ffffff;
      color: #000000;
      z-index: 9999;
      animation: fadeIn 0.5s ease-in-out;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    /* Container spinner + logo */
    .loader-circle {
      position: relative;
      width: 180px;
      height: 180px;
      margin-bottom: 15px;
      box-sizing: border-box;
      /* Pastikan border dihitung */
    }

    /* Spinner lingkaran */
    .loader-spinner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 8px solid rgba(0, 0, 255, 0.15);
      border-top: 8px solid #007bff;
      border-radius: 50%;
      animation: spin 1.5s linear infinite;
      transform: rotate(0deg);
      /* Start posisi lurus */
      box-sizing: border-box;
    }

    /* Logo di tengah */
    .loader-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 120px;
      height: auto;
      transform: translate(-50%, -50%);
      animation: pulseLogo 1.5s infinite ease-in-out;
    }

    /* Teks loading */
    .loader-text {
      font-size: 1.1rem;
      font-weight: 500;
      letter-spacing: 0.5px;
      animation: fadeInUp 1s ease-in-out;
    }

    @keyframes pulseLogo {
      0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.9;
      }

      50% {
        transform: translate(-50%, -50%) scale(1.1);
        opacity: 1;
      }

      100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.9;
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(10px);
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }`}
            </style>
        </>
    )
};